<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-fields-container">
        <ng-container *ngFor="let field of formData.fields">
            <app-dynamic-form-field
                [form]="form"
                [field]="field"
                [class]="{ 'full-row': field.fullRow }"
                (valueChange)="onFieldValueChange(field, $event)"
            ></app-dynamic-form-field>
        </ng-container>
    </div>

    <ng-content select="[message]"></ng-content>

    <div class="actions">
        <button mat-flat-button type="button" secondaryButton (click)="onCancel()">Cancel</button>
        <button mat-flat-button type="submit" primaryButton [disabled]="!isValid">Save</button>
    </div>
</form>
